/**
 * Created by glenn on 7/25/2017.
 */
import {RadioConnected} from 'webmapsjs/dist/reactComponents/Radio';
import {iState, setData, store} from './store';
import * as apiActions from '../../api/npmrds/actions';
import {connect} from "react-redux";

const mapStateToProps = (state: iState) => {
    let outArr: string[] = [];

    for (let f of state.roads) {
        if (f.number == null) {
            continue;
        }
        outArr.push(f.number + ' ' + f.direction)
    }

    return {
        title: "Roads and Directions",
        items: outArr,
        selectedIndex: state.roadIndex,
        inline: false,
        classes: []
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        callback: (val: string) => {
            dispatch({type: apiActions.ACTION_SET_ROAD_INDEX, roadIndex: parseInt(val)});
            // dispatch(makeRoadIndexAction(parseInt(val)));
            setData();
        }
    }
};

export const RadioHighway = connect(
    mapStateToProps,
    mapDispatchToProps
)(RadioConnected);